import PhotoLabelCarousel from "../components/PhotoLabelCarousel";
import Wrapper from "../components/Wrapper";
import { photos } from "../Data";


function Photos() {
    return (
        <Wrapper title={ "Photos" }>
            <div style={{height: "100%"}}>
                <PhotoLabelCarousel photos={photos} />
            </div>
        </Wrapper>
    )
}

export default Photos;
